import { Chip } from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';


export default function NormalTag({ tag }: { tag: { id: string; name: string } }) {
  return (
    <Chip
      key={tag.id}
      label={tag.name}
      size="small"
      sx={{
        backgroundColor: 'var(--color-primary-light)',
        color: 'var(--color-primary)',
        fontWeight: 500,
        fontSize: '0.75rem',
        '&:hover': {
          backgroundColor: 'var(--color-primary)',
          color: 'var(--color-background)'
        }
      }}
    />
  );
}

export function TagWithDelete({
  key, label, onDelete
}: {
  key: string;
  label: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onDelete: (() => void) | ((event: any) => void);
}) {
  return <>
    <Chip
      onDelete={(event) => {
        onDelete(event);
      }}
      key={key}
      label={label}
      deleteIcon={<ClearIcon className='text-[var(--color-foreground)]' sx={{ width: '16px', height: '16px' }} />}
      sx={{
        fontSize: '1rem',
        backgroundColor: 'var(--color-button-surface)',
        color: 'var(--color-foreground)',
        borderRadius: '12px'
      }}
    />
  </>
}